import { memo } from 'react';

const Body_: React.FC2 = ({ children, ...props }) => {
  return <div {...props}>{children}</div>;
};

export const Body = memo(Body_);
